<template>
	<app-header-teleport>
		<div class="flex flex-1 items-center">
			<app-title :title="$t('changePassword')" />
		</div>
	</app-header-teleport>
	<div class="mt-20 flex justify-center">
		<app-section class="bg-white xl:w-1/3 md:w-1/2 w-full m-4">
			<app-dynamic-form :schema="schema" @submit="changePassword" v-model="formData">
				<app-button class="btn btn-primary w-full" type="submit" :loading="state.loading">{{
					$t('changePassword')
				}}</app-button>
			</app-dynamic-form>
		</app-section>
	</div>
</template>
<script>
	import * as yup from 'yup';
	import { reactive, ref } from 'vue';
	import AppDynamicForm from '@/components/app/AppDynamicForm';
	import { useStore } from 'vuex';
	import AuthService from '@/services/AuthService';
	import { useTranslation } from 'i18next-vue';

	export default {
		components: {
			AppDynamicForm,
		},

		setup() {
			const store = useStore();
			const { t } = useTranslation();
			const schema = ref({
				oldPassword: {
					component: 'app-input',
					name: 'Old Password',
					placeholder: t('oldPassword'),
					type: 'password',
					icon: 'lock',
					validations: yup
						.string()
						.required()
						.label('Password'),
				},
				newPassword: {
					component: 'app-input',
					name: 'newPassword',
					placeholder: t('newPassword'),
					type: 'password',
					icon: 'lock',
					validations: yup
						.string()
						.required()
						.label('New Password'),
				},
				newPasswordConfirmed: {
					component: 'app-input',
					name: 'confirmPassword',
					placeholder: t('confirmPassword'),
					type: 'password',
					icon: 'lock',
					validations: yup
						.string()
						.required()
						.label('Confirm Password'),
				},
			});

			const formData = ref({
				oldPassword: '',
				newPassword: '',
				newPasswordConfirmed: '',
			});

			const state = reactive({
				loading: false,
			});

			function changePassword() {
				const password = formData.value;
				state.loading = true;
				AuthService.changePassword(store.getters.user.id, password).then(() => {
					state.loading = false;
					formData.value = {};
				});
			}

			return {
				changePassword,
				state,
				schema,
				formData,
			};
		},
	};
</script>
